import { USER_AUTHENTICATION } from "../Redux/type";

export const setUserAuthentication = (parameter) => {
  return {
    payload: parameter,
    type: USER_AUTHENTICATION,
  };
};
